import { HasClassName } from '~/types/HasClassName';

export function SortAscIcon({ className }: HasClassName) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960" fill="currentColor" className={className}>
      <path d="M440-240v-368L296-464l-56-56 240-240 240 240-56 56-144-144v368h-80Z" />
    </svg>
  );
}
